const MODULE_NAME = 'PATIENT_SURVEYS';
const PATIENT_SURVEYS_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const PATIENT_SURVEYS_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  PATIENT_SURVEYS_FETCH_COMPLETED,
  PATIENT_SURVEYS_FETCH_STARTED
};
